export default [
  { path: '/guide/station', name: 'GuideStation', component: () => import(/* webpackChunkName: "guide-station" */ './index.vue') },
  { path: '/guide/station/detail', name: 'GuideStationDetail', component: () => import(/* webpackChunkName: "guide-station-detail" */ './detail.vue') }
]